/**
 * Recruitment Page
 *
 * This is a thin wrapper around the generic SystemWorkspacePage.
 * The actual workspace logic is handled by the generic component.
 */

import React from "react";
import { SystemWorkspaceWrapper } from "./SystemWorkspacePage";
import type { DatasetName } from "@/common/constants";

/**
 * Required datasets for the Recruitment workspace
 */
const RECRUITMENT_REQUIRED_DATASETS: DatasetName[] = [
  "recruitment_applications",
];

/**
 * Recruitment workspace page component
 */
const RecruitmentPage: React.FC = () => {
  return (
    <SystemWorkspaceWrapper
      workspaceId="recruitment"
      requiredDatasets={RECRUITMENT_REQUIRED_DATASETS}
    />
  );
};

export default RecruitmentPage;
